// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --brand-accent-hover: color-mix(in srgb, var(--brand-accent, #2563eb) 85%, black);
  --brand-accent-soft: color-mix(in srgb, var(--brand-accent, #2563eb) 10%, white);
  display: block;
}

.site-footer {
  background: #ffffff;
  color: #374151;
  border-top: 1px solid #e7eaef;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.04);
}

.footer-main {
  padding: 48px 0 40px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.4fr repeat(3, 1fr);
  gap: 40px 32px;
}

.logo-link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: #1a1a1a;
  margin-bottom: 16px;
  transition: transform 0.3s ease;
}
.logo-link:hover {
  transform: scale(1.03);
}
.logo-link .logo-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: var(--brand-icon, var(--brand-accent, #2563eb));
  color: #fff;
  font-family: var(--brand-font-family, "Source Sans Pro", "Helvetica Neue", Arial, sans-serif);
  font-weight: 800;
  font-size: 20px;
  line-height: 1;
  margin-right: 12px;
  overflow: hidden;
}
.logo-link .logo-mark.logo-mark-image {
  background: transparent;
  padding: 0;
}
.logo-link .logo-mark.logo-mark-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.logo-link .brand {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
  color: #1a1a1a;
  font-family: var(--brand-font-family, "Source Sans Pro", "Helvetica Neue", Arial, sans-serif);
}

.tagline {
  font-size: 15px;
  line-height: 1.6;
  color: #6b7280;
  margin: 0 0 24px;
  max-width: 320px;
}

.contact-info p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 10px;
  font-size: 14px;
  color: #6b7280;
}
.contact-info p mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--brand-icon, var(--brand-accent, #2563eb));
}

.footer-column h4 {
  font-family: "Helvetica Neue", Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #1a1a1a;
  margin: 0 0 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid var(--brand-accent-soft);
}
.footer-column ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.footer-column ul li {
  margin-bottom: 10px;
}
.footer-column ul li a {
  color: #6b7280;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.25s ease, transform 0.25s ease;
  display: inline-block;
}
.footer-column ul li a:hover {
  color: var(--brand-accent);
  transform: translateX(3px);
}

.social-links {
  margin-top: 28px;
}
.social-links h5 {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #98a2b3;
  margin: 0 0 12px;
}

.social-icons {
  display: flex;
  gap: 8px;
}
.social-icons .social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f1f4f8;
  border: 1px solid #e2e6ec;
  color: #6b7280;
  text-decoration: none;
  transition: all 0.25s ease;
}
.social-icons .social-icon:hover {
  background: var(--brand-icon-soft, var(--brand-accent-soft));
  border-color: var(--brand-icon, var(--brand-accent, #2563eb));
  color: var(--brand-icon, var(--brand-accent, #2563eb));
  transform: translateY(-2px);
}
.social-icons .social-icon mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.footer-btm {
  background: #f8fafc;
  border-top: 1px solid #e7eaef;
  padding: 16px 0;
}

.footer-btm-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.copyright {
  margin: 0;
  font-size: 13px;
  color: #98a2b3;
}

.footer-btm-links {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 0;
  list-style: none;
  margin: 0;
  padding: 0;
}
.footer-btm-links li a {
  color: #6b7280;
  text-decoration: none;
  font-size: 13px;
  padding: 0 14px;
  border-right: 1px solid #e2e6ec;
  transition: color 0.25s ease;
}
.footer-btm-links li a:hover {
  color: var(--brand-accent);
}
.footer-btm-links li:last-child a {
  border-right: none;
  padding-right: 0;
}
.footer-btm-links li:first-child a {
  padding-left: 0;
}

@media (max-width: 960px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
  }
  .footer-brand {
    grid-column: 1/-1;
  }
}
@media (max-width: 600px) {
  .footer-main {
    padding: 36px 0 28px;
  }
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  .tagline {
    max-width: none;
  }
  .footer-btm-inner {
    flex-direction: column;
    align-items: flex-start;
  }
  .footer-btm-links li a {
    padding-left: 0;
    border-right: none;
    padding-right: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EACE,iFAAA;EACA,gFAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,6BAAA;EACA,2CAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,2CAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,+BAAA;AACF;AACE;EACE,sBAAA;AACJ;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2DAAA;EACA,WAAA;EACA,6FAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,uBAAA;EACA,UAAA;AAAN;AAEM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAAR;AAKE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,6FAAA;AAHJ;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAJF;;AAQE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AALJ;AAOI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,sDAAA;AALN;;AAWE;EACE,gDAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,iDAAA;AARJ;AAWE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AATJ;AAWI;EACE,mBAAA;AATN;AAWM;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,kDAAA;EACA,qBAAA;AATR;AAWQ;EACE,0BAAA;EACA,0BAAA;AATV;;AAgBA;EACE,gBAAA;AAbF;AAeE;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,QAAA;AAdF;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,0BAAA;AAdJ;AAgBI;EACE,4DAAA;EACA,6DAAA;EACA,sDAAA;EACA,2BAAA;AAdN;AAiBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAfN;;AAoBA;EACE,mBAAA;EACA,6BAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;AAjBF;;AAoBA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAjBF;AAoBI;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,+BAAA;EACA,4BAAA;AAlBN;AAoBM;EACE,0BAAA;AAlBR;AAsBI;EACE,kBAAA;EACA,gBAAA;AApBN;AAuBI;EACE,eAAA;AArBN;;AA0BA;EACE;IACE,8BAAA;EAvBF;EA0BA;IACE,iBAAA;EAxBF;AACF;AA2BA;EACE;IACE,oBAAA;EAzBF;EA4BA;IACE,0BAAA;IACA,SAAA;EA1BF;EA6BA;IACE,eAAA;EA3BF;EA8BA;IACE,sBAAA;IACA,uBAAA;EA5BF;EA+BA;IACE,eAAA;IACA,kBAAA;IACA,mBAAA;EA7BF;AACF","sourcesContent":[":host {\n  --brand-accent-hover: color-mix(in srgb, var(--brand-accent, #2563eb) 85%, black);\n  --brand-accent-soft: color-mix(in srgb, var(--brand-accent, #2563eb) 10%, white);\n  display: block;\n}\n\n.site-footer {\n  background: #ffffff;\n  color: #374151;\n  border-top: 1px solid #e7eaef;\n  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.04);\n}\n\n.footer-main {\n  padding: 48px 0 40px;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.footer-grid {\n  display: grid;\n  grid-template-columns: 1.4fr repeat(3, 1fr);\n  gap: 40px 32px;\n}\n\n.logo-link {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: none;\n  color: #1a1a1a;\n  margin-bottom: 16px;\n  transition: transform 0.3s ease;\n\n  &:hover {\n    transform: scale(1.03);\n  }\n\n  .logo-mark {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 38px;\n    height: 38px;\n    border-radius: 10px;\n    background: var(--brand-icon, var(--brand-accent, #2563eb));\n    color: #fff;\n    font-family: var(--brand-font-family, 'Source Sans Pro', 'Helvetica Neue', Arial, sans-serif);\n    font-weight: 800;\n    font-size: 20px;\n    line-height: 1;\n    margin-right: 12px;\n    overflow: hidden;\n\n    &.logo-mark-image {\n      background: transparent;\n      padding: 0;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        display: block;\n      }\n    }\n  }\n\n  .brand {\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 1px;\n    color: #1a1a1a;\n    font-family: var(--brand-font-family, 'Source Sans Pro', 'Helvetica Neue', Arial, sans-serif);\n  }\n}\n\n.tagline {\n  font-size: 15px;\n  line-height: 1.6;\n  color: #6b7280;\n  margin: 0 0 24px;\n  max-width: 320px;\n}\n\n.contact-info {\n  p {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin: 0 0 10px;\n    font-size: 14px;\n    color: #6b7280;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      color: var(--brand-icon, var(--brand-accent, #2563eb));\n    }\n  }\n}\n\n.footer-column {\n  h4 {\n    font-family: 'Helvetica Neue', Arial, sans-serif;\n    font-size: 13px;\n    font-weight: 600;\n    letter-spacing: 0.8px;\n    text-transform: uppercase;\n    color: #1a1a1a;\n    margin: 0 0 20px;\n    padding-bottom: 10px;\n    border-bottom: 2px solid var(--brand-accent-soft);\n  }\n\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n\n    li {\n      margin-bottom: 10px;\n\n      a {\n        color: #6b7280;\n        text-decoration: none;\n        font-size: 14px;\n        transition: color 0.25s ease, transform 0.25s ease;\n        display: inline-block;\n\n        &:hover {\n          color: var(--brand-accent);\n          transform: translateX(3px);\n        }\n      }\n    }\n  }\n}\n\n.social-links {\n  margin-top: 28px;\n\n  h5 {\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.8px;\n    text-transform: uppercase;\n    color: #98a2b3;\n    margin: 0 0 12px;\n  }\n}\n\n.social-icons {\n  display: flex;\n  gap: 8px;\n\n  .social-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    background: #f1f4f8;\n    border: 1px solid #e2e6ec;\n    color: #6b7280;\n    text-decoration: none;\n    transition: all 0.25s ease;\n\n    &:hover {\n      background: var(--brand-icon-soft, var(--brand-accent-soft));\n      border-color: var(--brand-icon, var(--brand-accent, #2563eb));\n      color: var(--brand-icon, var(--brand-accent, #2563eb));\n      transform: translateY(-2px);\n    }\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n.footer-btm {\n  background: #f8fafc;\n  border-top: 1px solid #e7eaef;\n  padding: 16px 0;\n}\n\n.footer-btm-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.copyright {\n  margin: 0;\n  font-size: 13px;\n  color: #98a2b3;\n}\n\n.footer-btm-links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 0;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n\n  li {\n    a {\n      color: #6b7280;\n      text-decoration: none;\n      font-size: 13px;\n      padding: 0 14px;\n      border-right: 1px solid #e2e6ec;\n      transition: color 0.25s ease;\n\n      &:hover {\n        color: var(--brand-accent);\n      }\n    }\n\n    &:last-child a {\n      border-right: none;\n      padding-right: 0;\n    }\n\n    &:first-child a {\n      padding-left: 0;\n    }\n  }\n}\n\n@media (max-width: 960px) {\n  .footer-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .footer-brand {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 600px) {\n  .footer-main {\n    padding: 36px 0 28px;\n  }\n\n  .footer-grid {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n\n  .tagline {\n    max-width: none;\n  }\n\n  .footer-btm-inner {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .footer-btm-links li a {\n    padding-left: 0;\n    border-right: none;\n    padding-right: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
